export const ENV: string = process.env.REACT_APP_ENV || (process.env.NODE_ENV || 'development')
export default ENV;
